"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSystemSettings = useSystemSettings;
var react_1 = require("react");
var system_settings_1 = require("../features/apis/system-settings");
var system_settings_2 = require("../interfaces/system-settings");
function useSystemSettings() {
    var _a;
    var _b = (0, system_settings_1.useGetSystemSettingsQuery)(undefined, {
        pollingInterval: 300000, // 5 minutes
    }), data = _b.data, isLoading = _b.isLoading;
    var settings = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.settings;
    var pollingIntervals = (0, react_1.useMemo)(function () {
        if (settings === null || settings === void 0 ? void 0 : settings.polling_intervals) {
            return settings.polling_intervals;
        }
        return system_settings_2.DEFAULT_POLLING_INTERVALS;
    }, [settings === null || settings === void 0 ? void 0 : settings.polling_intervals]);
    return {
        settings: settings,
        pollingIntervals: pollingIntervals,
        isLoading: isLoading,
    };
}
